import { useEffect, useRef, useState } from "react";
import i18n from "../../i18n";
import { useGetLanguagesQuery } from "../../services/api/language.api";
import style from "./LanguageSelection.module.css";
import Tooltip from "../tooltip/tooltip";
import { tWithKeyAttr as t } from "../../i18nHelper";
export const LanguageSelection = () => {
  
  const { data: languages = [], isLoading,error:myError } = useGetLanguagesQuery();
  const [open, setOpen] = useState(false);
    const [showTooltip, setShowTooltip] = useState(false);
  const [i18nReady, setI18nReady] = useState<boolean>(i18n.isInitialized);

  const [selectedLang, setSelectedLang] = useState<string | null>(null);

  const wrapperRef = useRef<HTMLDivElement>(null);

  const changeLanguage = (lang: string) => {
    setSelectedLang(lang);
    i18n.changeLanguage(lang);
    localStorage.setItem("i18nextLng", lang);
    setTimeout(() => {
      window.location.reload();
    }, 200);
  };

  const current =
    languages.find(
      (l) => l.code === selectedLang || l.code === localStorage.getItem("i18nextLng")
    ) || languages[0];

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Ensure we render nothing until i18n resources are loaded
  useEffect(() => {
    if (i18n.isInitialized) {
      setI18nReady(true);
      return;
    }
    const onInitialized = () => setI18nReady(true);
    // i18next emits 'initialized' once init completes
    // it may also emit 'loaded' when resources arrive; either is fine to unblock
    i18n.on('initialized', onInitialized);
    i18n.on('loaded', onInitialized);
    return () => {
      i18n.off('initialized', onInitialized);
      i18n.off('loaded', onInitialized);
    };
  }, []);

  const hasResources = i18nReady && !!i18n.language && i18n.hasResourceBundle(i18n.language, 'translation');

  // Hide the language UI until locales are loaded and languages are available
  if (isLoading || !languages.length || !hasResources) {
    return null;
  }

  return (
    <div className={style.languageContainer} ref={wrapperRef}>
      {current ? (
        <div className={style.languageIcon} onClick={(e) =>{ e.stopPropagation();setOpen(!open)}}>
          <div onMouseEnter={()=>setShowTooltip(true)} onMouseLeave={()=>setShowTooltip(false)} className={style.tooltipWrapper}>
            <Tooltip isShown={showTooltip}  position="bottom">
              {t("SELECT_YOUR_LANGUAGE")}
            </Tooltip>
            <img
              src={`https://flagcdn.com/${current.countryCode.toLowerCase()}.svg`}
              className={style.img}
              alt={current.name}
            />
          </div>

          {open && (
            <ul className={style.languagePopup}>
              <button
                className={style.closeButton}
                onClick={(e) => {e.stopPropagation();setOpen(false)}}
              >
                ✕
              </button>

              {languages
                .filter((x) => x.code !== current.code)
                .map((x, i) => (
                  <li
                    key={i}
                    onClick={() => {
                      changeLanguage(x.code);
                      setOpen(false);
                    }}
                    className={style.languageItem}
                  >
                    <img
                      src={`https://flagcdn.com/${x.countryCode.toLowerCase()}.svg`}
                      className={style.img}
                      alt={x.name}
                    />
                    <span>{x.name}</span>
                  </li>
                ))}
            </ul>
          )}
        </div>
      ) : (
        <span>{t("CHOOSE_LANGUAGE")}</span>
      )}
    </div>
  );
};
